// extracted by mini-css-extract-plugin
export default {"recos":"U5-z","productCardOverride":"V5-z","rowHasBadge":"W5-z"};